var link_viewer_default = {
  "fontElementMap": "-MXWj",
  "link": "ihYXw",
  "linkInEditor": "RQoms",
  "linkInViewer": "LFYPy",
  "toolbarUrlContainer": "i1FL8",
  "toolbarUrl": "s913T",
  "toolbarUrlAnchor": "Am7Cz"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
